<form clrForm
      [formGroup]="editTransportForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Zeichnungsnummer</th>
      <th class="left">Material</th>
      <th class="left">Serien-Nr.</th>
      <th class="left">Charge</th>
      <th class="left">Gewicht (in kg)</th>
      <th>Anzahl</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td class="left">
        <b>{{ positions[0].name }}</b>
        <span *ngIf="((!positions[0].description) || (positions[0].description.length > 0))"><br />{{ positions[0].description }}</span>
      </td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td class="left">{{ positions[0].material }}</td>
      <td class="left"><input type="text" formControlName="serial_nr" class="clr-input"></td>
      <td class="left"><input type="text" formControlName="heat_nr" class="clr-input"></td>
      <td class="left"><input type="text" formControlName="weight" class="clr-input"></td>
      <td><input type="text" formControlName="number_of_pieces" class="clr-input"></td>
      <td rowspan="5" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateTransportPosition()" [disabled]="editTransportForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Spezifikation</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].specification }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="positions[0].comment_phm">
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Kommentar</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].comment_phm }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="positions[0].side_agreements">
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Nebenabreden mit dem Lieferanten:</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].side_agreements }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Liefertext</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" cols="100" rows="10" class="clr-textarea"></textarea>
              <clr-icon class="clr-validate-icon" shape="exclamation-circle"></clr-icon>
            </div>
            <span class="clr-subtext">Dieses Feld erscheint im Dokument unter der Position.</span>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>



<!--<pre class="datepicker-output">
    {{ editTransportForm.value | json }}
</pre>-->




